import { debounce } from '../../utils/lodash-replacements';
import ScrollCarousel, { measureSlidesPerView } from '../../components/ScrollCarousel';

const SELECTORS = {
  viewport: '[data-carousel-lookbook-viewport]',
  track: '[data-carousel-lookbook-track]',
};

const carousels = [];

const init = () => {
  carousels.forEach((carousel) => {
    try {
      carousel.destroy();
    } catch (error) {
      console.log('err:', error);
    }
  });

  carousels.length = 0;

  document.querySelectorAll('[data-carousel-lookbook]').forEach((el) => {
    // NOTE: this used to bail on an `initialized` attribute that `init()` never
    // cleared, so the resize path destroyed each carousel and then skipped
    // rebuilding it — the lookbook was dead after the first resize. The
    // attribute is now set for parity with the other sections but is not used
    // as a re-init guard, because re-initializing is the whole point here.
    el.setAttribute('initialized', 'true');

    const viewport = el.querySelector(SELECTORS.viewport);
    const track = el.querySelector(SELECTORS.track);
    if (!viewport || !track || track.children.length === 0) {
      return;
    }

    const carousel = new ScrollCarousel(el, {
      selectors: SELECTORS,
      // Flickity `wrapAround: true`. `contain` and `groupCells` were both
      // false, and `imagesLoaded` needs no equivalent — the base class
      // remeasures as late images settle.
      //
      // The old config had two branches that differed only in `cellAlign`
      // ('left' above 767px, 'center' below). Scroll-snap has no grouping-safe
      // equivalent for centered alignment, so both now snap to `start` — the
      // same accepted limitation as the pods carousels (WIN-8070 Risk #10).
      // On mobile this means the active collection sits flush left instead of
      // centered with its neighbours peeking in on both sides.
      loop: true,
      prevNextButtons: true,
      // Flickity's default; the SCSS never hid them here.
      pageDots: true,
      draggable: true,
      slidesPerView: measureSlidesPerView(viewport, track.children[0]),
      ariaLabel: 'Lookbook carousel',
    });

    carousels.push(carousel);
  });
};

let prevWidth = window.innerWidth;

const handleResize = debounce(() => {
  const newWidth = window.innerWidth;
  const deltaWidth = newWidth - prevWidth;

  if (deltaWidth === 0) {
    return;
  }

  prevWidth = newWidth;

  init();
}, 500);

export default function () {
  if (document.querySelectorAll('[data-carousel-lookbook]').length === 0) {
    return;
  }

  init();

  window.addEventListener('resize', handleResize);
}
